import { join } from 'path';
import { createHashHistory } from 'history';
import { Card, CardBody, CardHeader, CardFooter, TabContent, TabPane, Nav, NavItem, Button, Row, Col, Container, NavLink } from 'reactstrap';
import { Prompt } from 'react-router-dom';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import entityComposition from '../common/classes/entityComposition';
import routeHelper from '../common/classes/routeHelper';
import EditorComponent from '../editor/editorComponent';
import SaveButton from '../common/controls/saveButton';
import Loader from '../common/loader';
const hashHistory = createHashHistory();
class FluidIssueEditor extends Component {
  constructor(props) {
    super(props);
    this.getSectionIndex = this.getSectionIndex.bind(this);
    this.getSectionFormat = this.getSectionFormat.bind(this);
    this.getSections = this.getSections.bind(this);
    this.handleSelectSection = this.handleSelectSection.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleViewReportClick = this.handleViewReportClick.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      sectionIndex: null
    };
  }
  componentWillUnmount() {
    const issueActions = this.props.issueActions;
    issueActions.showCancel();
  }
  getSectionIndex() {
    const sectionIndex = this.state.sectionIndex;
    if (sectionIndex) {
      return sectionIndex;
    }

    // return the first section.
    const sections = this.getSections();
    if (sections && sections.length > 0) {
      return sections[0].label;
    }
    // what should we return as default?
    return 'General';
  }
  getSections() {
    const _this$props$issue$act = this.props.issue.active.format,
      format = _this$props$issue$act === void 0 ? {} : _this$props$issue$act;
    if (format && format.children) {
      // Return only visible sections (i.e. visible is not set to false)
      return format.children.map(child => ({
        label: child.label,
        format: child
      })).filter(section => section.format.visible !== undefined && section.format.visible === true || section.format.visible === undefined);
    }
    return [];
  }
  getSectionFormat() {
    const sectionKey = this.getSectionIndex();
    const sections = this.getSections();
    const section = sections.find(currentSection => currentSection.label === sectionKey);
    return section ? section.format : undefined;
  }
  handleSelectSection(sectionkey) {
    this.setState({
      sectionIndex: sectionkey
    });
  }
  handleSave() {
    const handleSave = this.props.handleSave;
    handleSave(...arguments);
  }
  handleChange(_ref) {
    let path = _ref.path,
      value = _ref.value,
      changeModifiers = _ref.changeModifiers;
    const _this$props = this.props,
      issueActions = _this$props.issueActions,
      issueID = _this$props.issueID;
    // create a change action with the new info.
    // need to prepend the content object to this keypath
    issueActions.change(issueID, join('content', path), value, changeModifiers);
  }
  handleViewReportClick() {
    const reportID = this.props.issue.active.reportID;
    hashHistory.push("/reports/edit/".concat(reportID));
  }
  render() {
    const _this$props2 = this.props,
      handleSave = _this$props2.handleSave,
      _this$props2$issue = _this$props2.issue,
      active = _this$props2$issue.active,
      loading = _this$props2$issue.loading,
      pendingChanges = _this$props2$issue.pendingChanges,
      footer = _this$props2.footer,
      saveState = _this$props2.saveState,
      _this$props2$issueAct = _this$props2.issueActions,
      operationComplete = _this$props2$issueAct.operationComplete,
      operationPending = _this$props2$issueAct.operationPending;
    const reportID = active.reportID;
    const ready = active && active.issueType;
    const sectionIndex = this.getSectionIndex();
    const sectionFormat = this.getSectionFormat();
    const sections = this.getSections();
    let sectionKeyPath = null;
    if (sectionFormat && sectionFormat.children) {
      sectionKeyPath = sectionFormat.contentPath ? sectionFormat.contentPath : '/';
    }
    return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Prompt, {
      when: pendingChanges,
      message: location => routeHelper.transitionAsync(this, 'issue', location)
    }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 3
    }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
      className: "card-heading"
    }, /*#__PURE__*/React.createElement("h3", null, "Issue Sections")), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Nav, {
      vertical: true,
      pills: true
    }, sections.map(section => /*#__PURE__*/React.createElement(NavItem, {
      style: {
        maxWidth: '100%'
      },
      className: "t-re-nav-section-".concat(kebabCase(section.label)),
      active: sectionIndex === section.label,
      key: "NAV_".concat(section.label.replace(/[\s-]/g, ''))
    }, /*#__PURE__*/React.createElement(NavLink, {
      onClick: () => this.handleSelectSection(section.label)
    }, section.label))))))), /*#__PURE__*/React.createElement(Col, {
      sm: 9
    }, /*#__PURE__*/React.createElement(Card, {
      id: "detail-card-header",
      className: "t-section-panel"
    }, /*#__PURE__*/React.createElement(CardHeader, {
      className: "card-heading"
    }, reportID ? /*#__PURE__*/React.createElement("div", {
      style: {
        float: 'left'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      className: "float-right",
      onClick: this.handleViewReportClick
    }, "Edit Report")) : null, /*#__PURE__*/React.createElement("div", {
      style: {
        float: 'right',
        paddingBottom: active.id ? 0 : 20
      }
    }, /*#__PURE__*/React.createElement(SaveButton, {
      onSave: handleSave,
      saveState: saveState,
      className: "t-idvp-save",
      size: "sm"
    }))), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Loader, {
      loaded: !loading
    }, /*#__PURE__*/React.createElement(TabContent, {
      activeTab: sectionIndex
    }, sections.length ? sections.map(section => /*#__PURE__*/React.createElement(TabPane, {
      tabId: section.label,
      key: "KEY_".concat(kebabCase(section.label)),
      className: "t-i-nav-pane-".concat(kebabCase(section.label))
    }, ready ? /*#__PURE__*/React.createElement(EditorComponent, {
      minControlWidth: 25,
      reduxEntity: "issue",
      path: sectionKeyPath,
      format: sectionFormat,
      onChange: this.handleChange,
      operationComplete: operationComplete,
      operationPending: operationPending
    }) : null)) : /*#__PURE__*/React.createElement("h3", {
      className: "t-ie-edit-header"
    }, "Select an issue to edit or click to create")))), footer ? /*#__PURE__*/React.createElement(CardFooter, {
      style: {
        paddingLeft: 10,
        paddingRight: 10
      }
    }, footer) : null))));
  }
}
FluidIssueEditor.defaultProps = {
  saveState: 'disabled',
  issueID: null,
  footer: null
};
FluidIssueEditor.propTypes = {
  handleSave: PropTypes.func.isRequired,
  issueID: PropTypes.string,
  footer: PropTypes.node,
  issue: PropTypes.shape({
    active: PropTypes.shape({
      issueType: PropTypes.shape({}),
      reportID: PropTypes.string,
      content: PropTypes.shape({}),
      format: PropTypes.shape({}),
      id: PropTypes.string
    }),
    loading: PropTypes.bool,
    pendingChanges: PropTypes.bool
  }).isRequired,
  issueActions: PropTypes.shape({
    showCancel: PropTypes.func,
    change: PropTypes.func,
    operationPending: PropTypes.func,
    operationComplete: PropTypes.func
  }).isRequired,
  saveState: PropTypes.string
};
export { FluidIssueEditor as TestFluidIssueEditor };
export default entityComposition(FluidIssueEditor, ['issue']);